<script setup lang="ts">
import SectionTitle from '@/components/atoms/SectionTitle.vue'
import { useUserCourseLessonViewQuery } from './UserCourseLessonView.generated'
import { useRoute } from 'vue-router'
import UserCourseLessonCard from './UserCourseLessonCard/UserCourseLessonCard.vue'
import { computed } from 'vue'
import { KollegeUserCourseLessonStatus } from '@/types/schema.generated'

const route = useRoute('OkaneKollegeUserCourseLesson')

const query = useUserCourseLessonViewQuery({
  userId: route.params.userId,
})

const standardCourse = computed(
  () => query.result.value?.kollegeUser?.standardCourse
)

const totalLessonCount = computed(() => {
  if (!standardCourse.value) {
    return 0
  }
  return standardCourse.value.allLessons.length
})

const remainingLessonCount = computed(() => {
  if (!standardCourse.value) {
    return 0
  }

  const consumed = standardCourse.value.allLessons.filter(
    lesson =>
      lesson.status === KollegeUserCourseLessonStatus.Completed ||
      lesson.status === KollegeUserCourseLessonStatus.Absented
  )

  return (totalLessonCount.value ?? 0) - consumed.length
})
</script>

<template>
  <div v-if="standardCourse == null">
    パーソナルレッスンが登録されていません
  </div>
  <section v-else-if="standardCourse">
    <SectionTitle>パーソナルレッスン</SectionTitle>
    <p :class="$style.countBlock">
      残り回数：
      <span :class="$style.countText"
        ><span :class="$style.remainCount">{{ remainingLessonCount }}</span
        >/{{ totalLessonCount }}回</span
      >
    </p>
    <div :class="$style.lessonList">
      <UserCourseLessonCard
        v-for="lesson in standardCourse.allLessons"
        :key="lesson.id"
        :fragment="lesson"
      />
    </div>
  </section>
</template>

<style lang="scss" module>
.lessonList {
  margin-top: 24px;
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.countBlock {
  margin-top: 12px;
}

.countText {
  font-size: 18px;
  font-weight: bold;
}

.remainCount {
  color: $color-surface-accent-primary;
}
</style>
